// locales.mjs — 机器译文「徐呈」的纯逻辑（SB-067 二期，第六十五批）。
//
// OQ-B27 裁的地位决定了这里的每一条规则：
//   「自动译文以**机器翻译·未校**徐呈呈现，**原文始终并存且为准**，
//     不取代精翻、不进发布物。」
//
// 所以：
//   ① **永远不替换原文** —— 译文是详情页上**另一块**，不是同一块的另一种渲染。
//      写成 toggle 替换的话，看的人会不知道自己正在读的是哪一份。
//   ② **只在有用的时候出现** —— 界面语言与原文语言相同时不显示译文块：
//      给一个中文读者看中文原文旁边的英文译文，只是噪音。
//   ③ **必须打标** —— machine=true 的行一律带「机器翻译·未校」，
//      因为未校译文冒充权威文本正是 OQ-A1②/A19 当初要防的那件事。

// 挑出该显示的那一行。返回 null = 不显示译文块。
// `uiLang` 是界面语言，`sourceLang` 是工单的提交语言。
export function localeToShow(locales, uiLang, sourceLang) {
  if (!Array.isArray(locales) || locales.length === 0) return null;
  // 界面语言就是原文语言 ⇒ 读者本来就读得懂，不显示。
  if (uiLang === sourceLang) return null;
  // 优先给界面语言那一份；没有就不给（不要拿第三种语言充数）。
  return locales.find((l) => l && l.lang === uiLang) || null;
}

// 该不该打「机器翻译·未校」。精翻行（machine=false）不打——那时它是校过的文本。
export const isUnverified = (locale) => Boolean(locale && locale.machine);

// 译文还在路上：有源语言之外的界面语言、但还没有对应的译文行。
// 界面据此显示"翻译中"而不是什么都不显示——**什么都不显示**会让人以为这个系统
// 没有翻译功能，而它只是还没跑完。
export function isPending(locales, uiLang, sourceLang) {
  if (uiLang === sourceLang) return false;
  return !localeToShow(locales, uiLang, sourceLang);
}
